import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import classNames from 'classnames';

import style from './Slidedown.scss';

const Slidedown = ({ children, duration, ...props }) => (
  <Transition timeout={duration} {...props}>
    {state => {
      const child = React.Children.only(children);
      return React.cloneElement(child, {
        className: classNames(child.props.className, style.slidedown, style[`slidedown--${state}`]),
        style: { ...child.props.style, animationDuration: `${duration}ms` },
      });
    }}
  </Transition>
);

Slidedown.propTypes = {
  children: PropTypes.element,
  duration: PropTypes.number,
};

Slidedown.defaultProps = {
  duration: 300,
};

export default Slidedown;
